import React, { Component } from "react";
import { setSidebarVisibility } from "../../reducers/ui";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import SplitPane from 'react-split-pane';
import Pane from 'react-split-pane/lib/Pane';
//Component
import BaseMap from "../Map/BaseMap";
import SearchForm from "./SearchForm";
import ManageForm from "./ManageForm";
import AddGroupForm from "./AddGroupForm";
import WarningTypes from "./WarningTypes";

//Reducer
import { mapSetHazardPoints } from '../../reducers/map';
//import { searchReset } from '../../reducers/search';

const MIN_HEIGHT = 25;

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: '100%',
    height: '100%',
  },
  gridForm : {
    padding : '0px'
  },
  subheader: {
    width: '100%',
  },
});

class HazardPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }
  componentWillMount() {
    //this.props.searchReset(true);
    this.props.mapSetHazardPoints([]);
  }
  componentDidMount() {
    const { setSidebarVisibility } = this.props;

    setSidebarVisibility(false);
      
  }

  autosizeHeaders(event) {
    if (event.finished !== false) {
      event.api.setHeaderHeight(MIN_HEIGHT);
      const headerCells = document.querySelectorAll(
        "#locationMap .ag-header-cell-label"
      );

      let minHeight = MIN_HEIGHT;
      headerCells.forEach(cell => {
        minHeight = Math.max(minHeight, cell.scrollHeight);
      });
      event.api.setHeaderHeight(minHeight);
    }
  }
  renderManageForm(){
    switch(this.props.formManage.page){
      case 'manage' :
        return (<ManageForm/>);
      case 'warning_type' :
        return (<WarningTypes/>);
      case 'group' :
        return (<AddGroupForm
          type={this.state.mode}
          logistic={{ 
            value : this.state.logistic,
            text : this.state.logisticText
          }}
          location={{
            detail : this.state.locationDetail,
            value : this.state.location,
            text : this.state.locationText,
          }}/>);
      default : 
        return (<SearchForm/>);
    };
  }
  methodFromParent(cell) {
    alert("Parent Component Method from " + cell + "!");
  }
  render() {
    return (
      <div style={{ display: 'flex', height:'calc(100vh - 50px)' }}>
            <SplitPane split="vertical" minSize={50} defaultSize={100}>
                  <Pane initialSize="400px" minSize="200px" key={"key_sklanlksadlas"} >
                     <div style={{height:'calc(100vh - 40px)',overflow:'auto'}}>
                        {this.renderManageForm()}
                     </div>
                  </Pane>
                  <Pane key={"key_sajkgdjk92b9c"}  >
                    <div style={{ height:'calc(100vh - 52px)' }}>
                          <BaseMap isReset={this.props.isReset}/>
                    </div>
                  </Pane>
              </SplitPane>  
      </div>
    );
  }
}
const mapStateToProps = function(state) {
  return {
    isReset : state.map.isReset,
    formManage : state.ui.formManage,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    setSidebarVisibility: status => dispatch(setSidebarVisibility(status)),
    //searchReset: payload => dispatch(searchReset(payload)),
    mapSetHazardPoints: payload => dispatch(mapSetHazardPoints(payload)),
    dispatch
  };
};
const enhance = compose(
  connect( 
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
);
export default enhance(HazardPoints);

